import React  from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import PopoverContent from 'react-bootstrap/PopoverContent'
import PopoverTitle from 'react-bootstrap/PopoverTitle'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export default function InfoTooltip(props = {}) {

  const { 
    children, 
    placement = "top",
    className } = props;

  return (
    <span className={className}>
      <OverlayTrigger
        trigger="click"
        placement={placement}
        overlay={
          <Popover id={`popover-positioned-${placement}`} className="mx-2">
            <PopoverTitle as="h3">
              <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
            </PopoverTitle>
            <PopoverContent className="infoTooltipContent">
              {children}
            </PopoverContent>
          </Popover>
        }
      >
        <span className="infoTooltipTrigger">
          <FontAwesomeIcon size="lg" icon={faInfoCircle} />
        </span>
      </OverlayTrigger>
    </span>
  );
}